<template>
    <modal v-if="showModal" @close="$emit('closeModal')">
        <template slot="header">
            <h4 class="modal-title">{{title}}</h4>
            <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="$emit('closeModal')">
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <md-field>
                <label>Index Number</label>
                <md-input v-model="education.index_number"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.index_number"/>
            <md-field>
                <label>School Name</label>
                <md-input v-model="education.school_name"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.school_name"/>
            <md-field>
                <label>School Number</label>
                <md-input v-model="education.school_number"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.school_number"/>

            <select-input
                    v-model="education.exam_year"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    label=""
                    placeholder="Select  Exam Year"
                    :options="years"
                    :allow-empty="false"
            >
            </select-input>
            <validation-error :errors="apiValidationErrors.exam_year"/>


            <md-field>
                <label>Division / Class of award</label>
                <md-input v-model="education.division"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.division"/>

            <md-field>
                <label>Points / GPA </label>
                <md-input v-model="education.points"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.points"/>

            <select-input
                    v-model="education.exam_id"
                    deselect-label="Can't remove this value"
                    track-by="exam_id"
                    label="name"
                    placeholder="Select Relation Type"
                    :options="exams"
                    :allow-empty="false"
            >
            </select-input>
            <validation-error :errors="apiValidationErrors.exam_id"/>

            <select-input
                    v-model="education.region_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label=" "
                    placeholder="Select Region"
                    :options="regions"
                    :allow-empty="false"
            >
            </select-input>
            <validation-error :errors="apiValidationErrors.region_id"/>

            <select-input
                    v-if="education.region_id"
                    v-model="education.district_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label=" "
                    placeholder="Select District"
                    :options="districts"
                    :allow-empty="false"
            >
            </select-input>
            <validation-error :errors="apiValidationErrors.district_id"/>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="add">Add Education</md-button>
            <md-button
                    class="md-danger md-simple"
                    @click="$emit('closeModal')">Close
            </md-button>
        </template>
    </modal>
</template>

<script>
import {
    Modal
} from '@/components';
// import Multiselect from 'vue-multiselect'
import SelectInput from '../Inputs/SelectInput';
import formMixin from '@/mixins/form-mixin';
import ValidationError from '../ValidationError';

export default {
    name: 'AddSkillModal',
    components: { SelectInput, Modal,ValidationError },
    mixins: [formMixin],
    props: {
        title: {
            type: String, default: 'Add role'
        },
        labourer: {
            type: Object
        },
        showModal: {
            type: Boolean, default: false
        },
        multiple: {
            type: Boolean, default: true
        },
        model: {
            type: String, default: ''
        },
        modelType: {
            type: String, default: 'skills/list'
        }
    },
    data () {
        return {
            selected: [],
            neighborhoods: [],
            villages: [],
            wards: [],
            exams: [],
            districts: [],
            regions: [],
            education: {
                type:'labourerEducations',
                'labourer_id': '',
                'index_number': '',
                'school_name': '',
                'school_number': '',
                'exam_year': '',
                'division': '',
                'points': '',
                'exam_id': '',
                'region_id': '',
                'district_id': ''

            }
        };
    },
    created () {
        this.fetchData();
    },
    methods: {

        async add () {
            try {
                this.education.labourer_id = this.labourer.id;
                await this.$store.dispatch('labourerEducations/add', this.education);
                this.notifySuccess('Education added successfully.');
                this.$emit('addEducations', this.education);
            } catch (e) {
                console.log(e);
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        async fetchData () {
            await this.$store.dispatch('regions/list');
            this.regions = this.$store.getters['regions/list'];

            await this.$store.dispatch('districts/list');
            this.districts = this.$store.getters['districts/list'];

            await this.$store.dispatch('levels/list');
            this.exams = this.$store.getters['levels/list'];
        }
    },
    computed: {
        years () {
            const year = new Date().getFullYear();
            return Array.from({ length: year - 1970 }, (value, index) => {
                let y = year - index;
                return { name: y, id: y };
            });
        },
        district () {
            return this.education.district_id;
        },
        region () {
            return this.education.region_id;
        },
    },
    watch: {
        async region () {
            await this.$store.dispatch('regions/get', this.education.region_id);
            let region = this.$store.getters['regions/region'];
            this.districts = region.districts;
        },
        async district () {
            await this.$store.dispatch('districts/get', this.education.district_id);
            let district = this.$store.getters['districts/district'];
            this.wards = district.wards;
        },
    }
};
</script>

<style scoped>

</style>
